import { validateDesignDefinition } from '@mts/shared/blockDesign';

export const CONTENT_EDITOR_CATEGORY_LABELS = Object.freeze({
  text: 'Text', content: 'Content', media: 'Media', structure: 'Layout',
  design: 'Design', data: 'Local content', layout: 'Layout',
});

export function contentEditorCategoryLabel(category) {
  return CONTENT_EDITOR_CATEGORY_LABELS[category] || 'Content';
}

const NATIVE_BLOCK_PRESENTATION = Object.freeze({
  paragraph: {label:'Paragraph',category:'text'}, heading: {label:'Heading',category:'text'},
  bulletList: {label:'Bullet list',category:'text'}, orderedList: {label:'Numbered list',category:'text'},
  emailButton: {label:'Button',category:'text'}, emailImage: {label:'Image',category:'media'},
  emailDivider: {label:'Divider',category:'design'}, emailSpacer: {label:'Spacer',category:'layout'},
  emailCallout: {label:'Callout',category:'text'},
  blockquote: {label:'Block quote',category:'text'}, horizontalRule: {label:'Divider',category:'design'}, codeBlock: {label:'Code block',category:'text'},
});

/** Resolve insertion definitions once; every UI entry point receives the same registry. */
export function createContentEditorBlockRegistry(blocks) {
  const registry = new Map();
  for (const block of blocks) {
    const id = block.id || block.type;
    if (!id || registry.has(id)) throw new Error(`Duplicate or missing insertion identifier: ${id || '(missing)'}.`);
    if (!block.type || !Array.isArray(block.allowedParents)) throw new Error(`Insertion ${id} must declare a type and parent policy.`);
    if (block.designSupport) {
      const validation = validateDesignDefinition(block.type, block.designSupport);
      if (validation.length) throw new Error(validation.map((issue) => issue.message).join(' '));
    }
    const presentation = NATIVE_BLOCK_PRESENTATION[block.type];
    const generatedLabel = block.type.replace(/^email/, '').replace(/([A-Z])/g, ' $1').trim();
    registry.set(id, { ...block, id,
      label: presentation && (!block.label || block.label === generatedLabel) ? presentation.label : block.label,
      category: block.category || presentation?.category,
      keywords: [...(block.keywords || []), ...(presentation ? [generatedLabel] : [])],
    });
  }
  return registry;
}

export function searchContentEditorBlocks(blocks, query) {
  const needle = query.trim().toLocaleLowerCase();
  if (!needle) return [...blocks];
  const ranked = [];
  blocks.forEach((block, index) => {
    const label = String(block.label || '').toLocaleLowerCase();
    const fields = [label, ...(block.keywords || []).map((word) => word.toLocaleLowerCase()), String(block.category || '').toLocaleLowerCase(), contentEditorCategoryLabel(block.category).toLocaleLowerCase(), String(block.description || '').toLocaleLowerCase()];
    if (!fields.some((field) => field.includes(needle))) return;
    const score = label === needle ? 0 : label.startsWith(needle) ? 1 : label.includes(needle) ? 2 : fields.slice(1, -1).some((field) => field.includes(needle)) ? 3 : 4;
    ranked.push({ block, score, index });
  });
  return ranked.sort((left, right) => left.score - right.score || left.index - right.index).map(({ block }) => block);
}
